import * as d3 from 'd3';
const rotationScale = d3.scale.linear()
    .domain([-Math.PI / 2, Math.PI / 2])
    .range([0, 180]);
export default rotationScale;